<template>
    <div>
        <p class="font075" style="margin-bottom: 0;">({{length}} / 150 Zeichen)</p>
        <p v-for="error in errors.collect(question.id)" :key="error" class="errorText">
            {{ error }}
        </p>
        <textarea 
            type="text" 
            v-model="itemValue.value" 
            v-validate="{rules: {'required': question.required, 'max': [150], 'more_than_whitespace': true}}"
            :name="question.id" 
            :class="{'error': errors.has(question.id)}"
            :id="question.id"
            maxlength="150">
        </textarea>
    </div>
</template>
<script>
    import { Validator } from 'vee-validate';

    Validator.extend('more_than_whitespace', (value) => !((value != null && typeof value.trim === 'function' && value.trim().length == 0)));

	export default {
		name: 'profileInfoEditor',
		props: {
            item: Object,
            question: Object
        },
        inject: ['$validator'],
        data: function() {
            if (this.item.propertyValue == null) {
                this.item.propertyValue = {
                    value: '',
                    type: {
                        kind: 'STRING'
                    }
                }
            }
        	return {
                itemValue: this.item.propertyValue,
                length: this.item.propertyValue.value.length
        	}
        },
        watch: {
            itemValue: {
                handler: function(oldValue, newValue) {
                    this.length = newValue.value.length;
                    this.$emit('updateValue', this.question);
                },
                deep: true
            }
        },
        mounted: function() {
            this.$validator.validate('' + this.question.id);
        },
        methods: {
            isUrl: function() {
                return this.question.propertyInfo.key.value.endsWith('.url');
            }
        }
	}
</script>


// WEBPACK FOOTER //
// ProfileInfoEditor.vue?5a596639